import React from "react";
import {
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Theme,
  makeStyles,
  createStyles,
  Grid,
  ListItemSecondaryAction,
  IconButton,
  Box,
} from "@material-ui/core";
import { LoadingComponent } from "../../components/Loading";
import { IFolder } from "../../core/redux/dataMap/folder";
import { IArticle } from "../../core/redux/dataMap/article";
import DeleteOutlineIcon from "@material-ui/icons/DeleteOutline";
import { Droppable } from "react-beautiful-dnd";

interface IFolderListProps {
  folders: IFolder[];
  loading: boolean;
  setArticleList(articles: IArticle[]): void;
  selectFolder: React.Dispatch<React.SetStateAction<IFolder>>;
  selectedFolder: IFolder;
  setTitle: React.Dispatch<React.SetStateAction<string>>;
  setRootFolder(): void;
  openDeleteModal(IFolder): void;
}

export const FolderList: React.FC<IFolderListProps> = ({
  folders,
  loading,
  setArticleList,
  selectedFolder,
  selectFolder,
  setTitle,
  setRootFolder,
  openDeleteModal,
}) => {
  const classes = useStyles();

  const handleListClick = (folder) => {
    setArticleList(folder.articles);
    selectFolder(folder);
    setTitle(folder.name);
  };

  const getInitials = (folderName) => {
    const folderNameList = folderName.split(" ");
    return folderNameList.length > 1
      ? folderNameList[0][0].toLocaleUpperCase() +
          folderNameList[folderNameList.length - 1][0].toLocaleUpperCase()
      : folderNameList[0][0].toLocaleUpperCase();
  };

  return (
    <div>
      <List className={classes.root} component="nav">
        <Grid container direction="column">
          <ListItem
            button
            onClick={setRootFolder}
            selected={!selectedFolder || !selectedFolder.id}
            className={classes.listItem}
            component="nav"
          >
            <ListItemIcon>
              <div className={classes.folderInitials}>H</div>
            </ListItemIcon>
            <ListItemText primary="Home" />
          </ListItem>
          {loading ? (
            <ListItem className={classes.loading} component="nav">
              <LoadingComponent width="100px" />
            </ListItem>
          ) : (
            folders &&
            folders.map((folder) => {
              if (!folder.parentFolder)
                return (
                  <Droppable
                    droppableId={"column-folder-" + folder.id}
                    style={{ height: "100%" }}
                    key={folder.id}
                    isDropDisabled={
                      !!selectedFolder && selectedFolder.id === folder.id
                    }
                  >
                    {(provided, snapshot) => {
                      return (
                        <>
                          <ListItem
                            button
                            onClick={() => handleListClick(folder)}
                            ref={provided.innerRef}
                            {...provided.droppableProps}
                            selected={
                              selectedFolder && selectedFolder.id === folder.id
                            }
                            component="nav"
                            className={classes.listItem}
                          >
                            <ListItemIcon>
                              <div className={classes.folderInitials}>
                                {getInitials(folder.name)}
                              </div>
                            </ListItemIcon>
                            <ListItemText>
                              <Box
                                textOverflow="ellipsis"
                                component="div"
                                className={classes.folderName}
                              >
                                {folder.name}
                              </Box>
                            </ListItemText>
                            <ListItemSecondaryAction>
                              <IconButton
                                size="small"
                                onClick={() => openDeleteModal(folder)}
                              >
                                <DeleteOutlineIcon
                                  className={classes.deleteIcon}
                                />
                              </IconButton>
                            </ListItemSecondaryAction>
                          </ListItem>
                          <div style={{ display: "none" }}>
                            {provided.placeholder}
                          </div>
                        </>
                      );
                    }}
                  </Droppable>
                );
            })
          )}
        </Grid>
      </List>
    </div>
  );
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: "flex",
    },
    listItem: {
      paddingLeft: "25px",
    },
    folderInitials: {
      width: "23px",
      height: "23px",
      background: "#9BCE63",
      borderRadius: "4px",
      color: "#fff",
      textAlign: "center",
    },
    deleteIcon: {
      color: "#ccc",
    },
    loading: {
      display: "flex",
      justifyContent: "center",
    },
    folderName: {
      width: "86px",
      whiteSpace: "nowrap",
      display: "block",
      overflow: "hidden",
    },
  })
);
